module.exports = __webpack_public_path__ + "media/images/layouts/horse_shoe-4f1d4b02cbcce94cb59ad33f259bd5e0.png";